import CaseTable from './CaseTable';

export default CaseTable;
